export const BASEURL = "https://triptickbackend.vercel.app";
// export const BASEURL = "http://localhost:5000";

// export const BASEURL = "https://triptick-backend.vercel.app"; 
